const PALETTES = {
  phosphor: {
    name: 'Phosphor',
    bg:        '#0b0f0c',
    bgPanel:   '#0f1411',
    bgRaised:  '#131915',
    border:    '#1d2620',
    borderHi:  '#2a3a30',
    textHi:    '#e6f0e8',
    text:      '#aab8ad',
    textDim:   '#5e6e63',
    textFaint: '#3a4a3f',
    accent:    '#7af0a4',
    accentDim: '#3a8a55',
    accentBg:  'rgba(122,240,164,.08)',
    warn:      '#f0c674',
    rose:      '#f08aa8',
  },
  ember: {
    name: 'Ember',
    bg:        '#100a07',
    bgPanel:   '#161009',
    bgRaised:  '#1c150b',
    border:    '#2a200f',
    borderHi:  '#3a2c15',
    textHi:    '#f0e6d8',
    text:      '#b8a690',
    textDim:   '#6a5e4d',
    textFaint: '#4a4032',
    accent:    '#f0a062',
    accentDim: '#a06430',
    accentBg:  'rgba(240,160,98,.08)',
    warn:      '#f0d674',
    rose:      '#f08a8a',
  },
  bone: {
    name: 'Bone',
    bg:        '#0c0c0e',
    bgPanel:   '#111114',
    bgRaised:  '#16161a',
    border:    '#22222a',
    borderHi:  '#2e2e38',
    textHi:    '#ece9e2',
    text:      '#a8a59c',
    textDim:   '#5e5b54',
    textFaint: '#3a3934',
    accent:    '#ece9e2',
    accentDim: '#807d76',
    accentBg:  'rgba(236,233,226,.06)',
    warn:      '#e8c97a',
    rose:      '#e89aae',
  },
};

export default PALETTES;
